<mat-card class="mat-elevation-z0 employee-filter-string-form-field" [ngClass]="{'invisible':formElement.hidden === 'true'}">
    <mat-card-title class="header">
        <h5>{{ formElement.text }}</h5>
        <span class="asterisk" *ngIf="formElement.requiredField === 'true'">*</span>
    </mat-card-title>

    <mat-card-content>
        <div class="page-description-section" appLocalizationPopupDirective localizationCode="EmployeeFilterSelectionMsg">
            {{ 'EmployeeFilterSelectionMsg' | translate: {Default: "All the employees displayed will be selected."} }}
        </div>

        <app-data-grid-comp
            class="select-employee-data-grid"
            [hideActionButtons]="true"
            [columns]="columns"
            [filterCategories]="filterCategories"
            [gridDataResult]="gridDataResult"
            [pageSize]="pageSize"
            [skip]="skip"
            [isLoading]="isLoading"
            searchable="true"
            [sortable]="{
                mode: 'multiple'
            }"
            maxHeight="40"
            [sortableColumns]="sortableColumns"
            [tableId]="db_tables.Talent"
            [filter]="filter"
            [filters]="filters"
            (emitPageChangeEvent)="pageChange($event)"
            (emitSearchEvent)="search($event)"
            (emitFilterEvent)="filterCallback($event)"
            (emitSortEvent)="sortChange($event)"
        ></app-data-grid-comp>
    </mat-card-content>
</mat-card>